import React from "react";
import { useDispatch } from "react-redux";
import { HeaderComp } from "./TambahPegawai/HeaderComp";
import {
  InputFieldResponsive,
  SelectFieldResponsive,
} from "../component/Utils";
import DatePicker from "react-datepicker";
import { Label, Button, Form } from "reactstrap";
import { postDataAction } from "../config/redux/action";
import {
  PG_NAMA,
  PG_NIK,
  PG_TEMPAT_LAHIR,
  PG_TANGGAL_LAHIR,
  PG_S1,
  PG_S2,
  PG_S3,
  PG_SMA,
  PG_SMP,
  PG_ALAMAT,
  PG_KELURAHAN,
  BASE_URL,
  PG_POSISI,
  PG_TINGKAT,
  PG_DIVISI,
  PG_DEPARTEMEN,
  PG_PERFORMA,
  PG_PENGEMBANGAN,
  PG_MULAIKERJA,
  PG_TALENT,
} from "../constants";
import { Loader, Button as ButtonS } from "semantic-ui-react";
import Axios from "axios";
import { axiosConfig } from "../utils/helper";
import {
  performance,
  talent,
  development,
  jenisKelamin,
} from "./Pegawai/LevelPegawai";
import LoadingTop from "../component/LoadingTop";

const ActionButton = () => {
  const batal = (e) => {
    e.preventDefault();
    window.history.back();
  };
  return (
    <div className="d-flex justify-content-end">
      <Button type="button" className="mr-3" onClick={(e) => batal(e)}>
        Batal
      </Button>
      <ButtonS type="submit" color="blue">
        Simpan
      </ButtonS>
    </div>
  );
};

export default () => {
  const dispatch = useDispatch();
  const [pegawai, setPegawai] = React.useState();
  const [provinsiList, setProvinsiList] = React.useState([]);
  const [kabupatenList, setKabupatenList] = React.useState([]);
  const [kecamatanList, setKecamatanList] = React.useState([]);
  const [kelurahanList, setKelurahanList] = React.useState([]);
  React.useEffect(() => {
    Axios.get(`${BASE_URL}/provinsi`, axiosConfig).then((r) =>
      setProvinsiList(r.data)
    );
  }, []);

  const handleChange = (event, type) => {
    const { name, value } = event.target;
    setPegawai({ ...pegawai, [name]: value });
  };

  const handleChangeDate = (name, value, type) => {
    setPegawai({ ...pegawai, [name]: value });
  };

  const changeProvinsi = (provinsiId, init = false) => {
    if (!init) setPegawai({ ...pegawai, provinsi: provinsiId });
    const url = `${BASE_URL}/kabupaten/provinsi/${provinsiId}`;
    Axios.get(url, axiosConfig()).then((r) => {
      setKabupatenList(r.data);
      if (!init) {
        setKecamatanList([]);
        setKelurahanList([]);
      }
    });
  };

  const changeKabupaten = (kabupatenId, init = false) => {
    const url = `${BASE_URL}/kecamatan/kabupaten/${kabupatenId}`;
    Axios.get(url, axiosConfig()).then((r) => {
      setKecamatanList(r.data);
      if (!init) {
        setKelurahanList([]);
      }
    });
  };

  const changeKecamatan = (kecamtanId, init = false) => {
    const url = `${BASE_URL}/kelurahan/kecamatan/${kecamtanId}`;
    Axios.get(url, axiosConfig()).then((r) => setKelurahanList(r.data));
  };

  const submit = (e) => {
    e.preventDefault();
    const param = {
      path: "pegawai",
      body: pegawai,
      title: "Pegawai",
    };
    dispatch(postDataAction(param)).then((response) => window.history.back());
  };

  return (
    <>
      <HeaderComp title="Tambah Pegawai" />
      <LoadingTop />
      <Form onSubmit={submit}>
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                <ActionButton />
                <hr />
                <div className="mb-3">
                  <h4>Profile</h4>
                  <InputFieldResponsive
                    label="NIK *"
                    inputType={{
                      disabled: false,
                      required: true,
                      name: "nik",
                    }}
                    onChange={(e) => handleChange(e, PG_NIK)}
                  />
                  <InputFieldResponsive
                    label="Nama Lengkap *"
                    inputType={{
                      disabled: false,
                      required: true,
                      name: "nama",
                    }}
                    onChange={(e) => handleChange(e, PG_NAMA)}
                  />
                  <SelectFieldResponsive
                    label="Jenis Kelamin"
                    inputType={{ options: jenisKelamin }}
                    onChange={(e, v) =>
                      handleChangeDate("jenisKelamin", v.value, PG_TALENT)
                    }
                  />
                  <InputFieldResponsive
                    label="No. Telepon"
                    inputType={{
                      disabled: false,
                      name: "telepon",
                    }}
                    onChange={handleChange}
                  />
                  <InputFieldResponsive
                    label="Email"
                    inputType={{
                      disabled: false,
                      name: "email",
                    }}
                    onChange={handleChange}
                  />
                  <InputFieldResponsive
                    label="Tempat Lahir"
                    inputType={{
                      disabled: false,
                      name: "tempatLahir",
                    }}
                    onChange={(e) => handleChange(e, PG_TEMPAT_LAHIR)}
                  />
                  <div className="row mb-2">
                    <div className="col-md-4 d-flex align-items-center">
                      <Label>Tanggal Lahir</Label>
                    </div>
                    <div className="col-md-8">
                      <DatePicker
                        selected={pegawai?.tanggalLahir}
                        onChange={(date) =>
                          handleChangeDate(
                            "tanggalLahir",
                            date,
                            PG_TANGGAL_LAHIR
                          )
                        }
                        className="form-control"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        maxDate={new Date()}
                        openToDate={new Date("1997/01/01")}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <h4>Alamat</h4>
                  <InputFieldResponsive
                    label="Alamat Lengkap"
                    onChange={(e) => handleChange(e, PG_ALAMAT)}
                    inputType={{
                      disabled: false,
                      type: "textarea",
                      name: "alamat",
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    onChange={(e, v) => changeProvinsi(v.value)}
                    label="Provinsi"
                    inputType={{
                      options: provinsiList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    label="Kota/Kabupaten"
                    onChange={(e, v) => changeKabupaten(v.value)}
                    inputType={{
                      options: kabupatenList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    label="Kecamatan"
                    onChange={(e, v) => changeKecamatan(v.value)}
                    inputType={{
                      options: kecamatanList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    label="Kelurahan"
                    onChange={(e, v) =>
                      handleChangeDate("kelurahanId", v.value, PG_KELURAHAN)
                    }
                    inputType={{
                      options: kelurahanList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                </div>
                <div className="mb-3">
                  <h4>Pendidikan</h4>
                  <InputFieldResponsive
                    label="SMP"
                    inputType={{
                      disabled: false,
                      name: "smp",
                    }}
                    onChange={(e) => handleChange(e, PG_SMP)}
                  />
                  <InputFieldResponsive
                    label="SMA"
                    inputType={{
                      disabled: false,
                      name: "sma",
                    }}
                    onChange={(e) => handleChange(e, PG_SMA)}
                  />
                  <InputFieldResponsive
                    label="S1"
                    inputType={{
                      disabled: false,
                      name: "s1",
                    }}
                    onChange={(e) => handleChange(e, PG_S1)}
                  />
                  <InputFieldResponsive
                    label="S2"
                    inputType={{
                      disabled: false,
                      name: "s2",
                    }}
                    onChange={(e) => handleChange(e, PG_S2)}
                  />
                  <InputFieldResponsive
                    label="S3"
                    inputType={{
                      disabled: false,
                      name: "s3",
                    }}
                    onChange={(e) => handleChange(e, PG_S3)}
                  />
                </div>
                <div className="mb-3">
                  <h4>Pekerjaan</h4>
                  <div className="row mb-2">
                    <div className="col-md-4 d-flex align-items-center">
                      <Label>Tanggal Masuk</Label>
                    </div>
                    <div className="col-md-8">
                      <DatePicker
                        onChange={(date) =>
                          handleChangeDate("mulaiKerja", date, PG_MULAIKERJA)
                        }
                        className="form-control"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        maxDate={new Date()}
                        openToDate={new Date("1997/01/01")}
                      />
                    </div>
                  </div>
                  <InputFieldResponsive
                    label="Posisi"
                    onChange={(e) => handleChange(e, PG_POSISI)}
                    inputType={{
                      disabled: false,
                      name: "posisi",
                    }}
                  />
                  <InputFieldResponsive
                    label="Tingkat"
                    onChange={(e) => handleChange(e, PG_TINGKAT)}
                    inputType={{
                      disabled: false,
                      name: "tingkat",
                    }}
                  />
                  <InputFieldResponsive
                    label="Divisi"
                    onChange={(e) => handleChange(e, PG_DIVISI)}
                    inputType={{
                      disabled: false,
                      name: "divisi",
                    }}
                  />
                  <InputFieldResponsive
                    label="Departemen"
                    onChange={(e) => handleChange(e, PG_DEPARTEMEN)}
                    inputType={{
                      disabled: false,
                      name: "departemen",
                    }}
                  />
                  <SelectFieldResponsive
                    label="Peforma"
                    onChange={(e, v) =>
                      handleChangeDate("performa", v.value, PG_PERFORMA)
                    }
                    inputType={{
                      options: performance,
                    }}
                  />
                  <SelectFieldResponsive
                    label="Bakat"
                    inputType={{ options: talent }}
                    onChange={(e, v) =>
                      handleChangeDate("bakat", v.value, PG_TALENT)
                    }
                  />
                  <SelectFieldResponsive
                    label="Pengembangan"
                    onChange={(e, v) =>
                      handleChangeDate("pengembangan", v.value, PG_PENGEMBANGAN)
                    }
                    inputType={{
                      options: development,
                    }}
                  />
                </div>
                <hr />
                <ActionButton />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};
